<template>
    <div>
        <div :class="link_state===''?'':'not_display'">
            <div class="skill_category_list">
                <p class="eval_state_part">评估分析内容</p>
                <p class="eval_state_part">现职位目前Top排名</p>
                <p class="eval_state_part">目标职位目前Top排名</p>
                <p class="eval_state_part">排名变动</p>
            </div>
            <v-loader :source="rate_info_line_1" :urls="['/api/v2/get_position_rate_info/']">
                <div class="skill_category_list" v-for="(info, index) in rate_info_line_2" :key="index">
                    <p :class="index !== 1 && index !== 2?'eval_state_part':'not_display'">{{ table_1_column[index] }}</p>
                    <p :class="index !== 1 && index !== 2?'eval_state_part':'not_display'">{{ info['rate'] }}</p>
                    <p :class="index !== 1 && index !== 2?'eval_state_part':'not_display'">{{ rate_info_line_1[index]['rate'] }}</p>
                    <p :class="index !== 1 && index !== 2?'eval_state_part':'not_display'"></p>
                </div>
                <div class="skill_category_list" v-for="(info, ind) in rate_info_line_4" :key="ind">
                    <p :class="ind !== 0?'eval_state_part':'not_display'">{{ table_2_column[ind] }}</p>
                    <p :class="ind !== 0?'eval_state_part':'not_display'">{{ info['rate'] }}</p>
                    <p :class="ind !== 0?'eval_state_part':'not_display'">{{ rate_info_line_3[ind]['rate'] }}</p>
                    <p :class="ind !== 0?'eval_state_part':'not_display'"></p>
                </div>
            </v-loader>
        </div>
        <div :class="link_state===''?'not_display':''">
            <div class="skill_category_list">
                <p class="skill_state_part">技能分类</p>
                <p class="skill_state_part">目标完成后得分</p>
                <p class="skill_state_part">目标完成后Top排名</p>
            </div>
            <div class="skill_category_list" v-for="(category_info, index) in skill_category_info" :key="index">
                <p class="skill_state_part">{{ category_info[0] }}</p>
                <p class="skill_state_part">{{ category_info[1] }}</p>
                <p class="skill_state_part">{{ category_info[2] }}</p>
            </div>
        </div>

    </div>
</template>
<script type="text/javascript">

import { mapState, mapActions  } from 'vuex'

export default {
    data: function () {
        return {
            link_state: '',
            table_1_column:['职位的年龄排名', '所属行业中的年龄排名', '管理下属数量排名', '所在企业规模排名', '同学历中的年龄排名'],
            table_2_column:['同行业同职位薪资排名', '同年龄薪资排名', '同职位薪资排名', '同等规模企业薪资排名', '同学历中的薪资排名'],
        }
    },
    methods: {
        ...mapActions({
            get_skill_category_info: 'skill/get_skill_category_info_for_target',
            get_rate_info: 'eval_position/get_rate_info_target',
        })
    },
    computed: {
        ...mapState({
            skill_category_info: state => state.skill.skill_category_info,
            rate_info_line_1: state => state.eval_position.rate_info_line_1,
            rate_info_line_2: state => state.eval_position.rate_info_line_2,
            rate_info_line_3: state => state.eval_position.rate_info_line_3,
            rate_info_line_4: state => state.eval_position.rate_info_line_4,
        })
    },
    mounted: function () {
        this.get_skill_category_info()
        this.link_state = localStorage.getItem('field')
        if(this.link_state === ''){
            this.get_rate_info()
        }
    }
}

</script>
<style type="text/css">
.skill_category_list {
    display: flex;
    flex-wrap: wrap;
    background: #fff;
}
.skill_state_part {
    width: 33%;
    padding: 10px 15px;
    font-size: 16px;
    color: #565656;
    max-height: 45px;
    overflow: hidden;
    word-break: break-word;
    text-overflow: ellipsis;
}
    .not_display{
        display: none;
    }
.eval_state_part {
    width: 25%;
    padding: 5px 15px;
    font-size: 16px;
    color: #565656;
    max-height: 45px;
    overflow: hidden;
    word-break: break-word;
    text-overflow: ellipsis;
}


</style>
